import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    children: [
      {
        path: '/apps',
        name: 'apps',
        component: () => import('../views/AppView.vue')
      },
      {
        path: '/overview',
        name: 'overview',
        component: () => import('../views/Dashboard.vue')
      },
      {
        path: '/clickstat',
        name: 'clickstat',
        component: () => import('../views/Overview.vue')
      },
      {
        path: '/gamedata',
        name: 'gamedata',
        component: () => import('../views/GameData.vue')
      },
      {
        path: '/addata',
        name: 'addata',
        component: () => import('../views/AdData.vue')
      },
      {
        path: '/adtypedata',
        name: 'adtypedata',
        component: () => import('../views/AdTypeData.vue')
      },
      {
        path: '/admanage',
        name: 'admanage',
        component: () => import('../views/AdManage.vue')
      },
      {
        path: '/admedia',
        name: 'admedia',
        component: () => import('../views/AdMedia.vue')
      },
      {
        path: '/publish',
        name: 'publish',
        component: () => import('../views/AdPublish.vue')
      },
      {
        path: '/adgroup',
        name: 'adgroup',
        component: () => import('../views/AdGroup.vue')
      },
      {
        path: '/adplace',
        name: 'adplace',
        component: () => import('../views/AdPlacementStat.vue')
      },
      {
        path: '/revenue',
        name: 'revenue',
        component: () => import('../views/AdRevenue.vue')
      },
      {
        path: '/downstream',
        name: 'downstream',
        component: () => import('../views/Downstream.vue')
      },
      {
        path: '/rubbish_media',
        name: 'rubbish_media',
        component: () => import('../views/RubbishMedia.vue')
      },
      {
        path: '/patch',
        name: 'patch',
        component: () => import('../views/PatchView.vue')
      },
      {
        path: '/gamereports',
        name: 'gamereports',
        component: () => import('../views/GameReports.vue')
      },
      {
        path: '/roas/:package_name',
        name: 'Roas',
        component: () => import('../views/RoasData.vue')
      },
      {
        path: '/white',
        name: 'white',
        component: () => import('../views/WhiteList.vue')
      },
      {
        path: '/ad',
        name: 'ad',
        component: () => import('../views/Apps.vue')
      },
      {
        path: '/ad_set',
        name: 'ad_set',
        // component: () => import('../views/Apps.vue')
        component: () => import('../views/AdSet.vue')
      },
      {
        path: '/collocation',
        name: 'collocation',
        component: () => import('../views/Collocation.vue')
      },
      {
        path: '/price_guard',
        name: 'price_guard',
        component: () => import('../views/PriceGuard.vue')
      },
      {
        path: '/crash',
        name: 'crash',
        component: () => import('../views/Crash.vue')
      },
      {
        path: '/game_revenue',
        name: 'game_revenue',
        component: () => import('../views/AdGameRevenue.vue')
      },
      {
        path: '/cost_report',
        name: 'cost_report',
        component: () => import('../views/AdCost.vue')
      },
      {
        path: '/oppo_adv',
        name: 'oppo_adv',
        component: () => import('../views/OppoAdv.vue')
      },
      {
        path: '/ecpm',
        name: 'ecpm',
        component: () => import('../views/EcpmView.vue')
      },
      {
        path: '/abnormal_placement',
        name: 'abnormal_placement',
        component: () => import('../views/AbnormalPlacement.vue')
      },
      {
        path: '/adv_cost',
        name: 'adv_cost',
        component: () => import('../views/AdvCost.vue')
      },
      
    ]
  },
  {
    path: '/admin_login',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/Login.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
